import React, { ReactElement } from "react";
import {
  OverlijdensRisicoVerzekering,
  VoorstelOverlijdensrisicoverzekeringHoofdstuk,
} from "../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../components/Chapter";
import Heading from "../../components/Heading";
import { getOrvColumns } from "../Producten/orv-kolommen";
import Table from "../../components/Table";

type OverlijdensrisicoverzekeringChapterProps = {
  hoofdstuk: VoorstelOverlijdensrisicoverzekeringHoofdstuk;
};

const overlijdensrisicoverzekering = ({
  overlijdensrisicoverzekering,
  index,
}: {
  overlijdensrisicoverzekering: OverlijdensRisicoVerzekering;
  index: number;
}): ReactElement => {
  const columns = getOrvColumns({
    overlijdensrisicoverzekering,
    isHuidig: false,
  });
  const data = [overlijdensrisicoverzekering];

  return (
    <Table
      columns={columns}
      data={data}
      rotate
      id="overlijdensrisicoverzekering-table1"
      className="overlijdensrisicoverzekering-table1"
    />
  );
};

const OverlijdensrisicoverzekeringChapter = ({
  hoofdstuk,
}: OverlijdensrisicoverzekeringChapterProps): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        {hoofdstuk.titel && <Heading text={`${hoofdstuk.titel}`} level={3} />}

        {hoofdstuk.overlijdensRisicoVerzekeringen
          ?.slice(0, 1)
          .map((verzekering: OverlijdensRisicoVerzekering, index) => {
            return (
              <div key={`verzekering-${index}`}>
                {overlijdensrisicoverzekering({
                  overlijdensrisicoverzekering: verzekering,
                  index,
                })}
              </div>
            );
          })}
      </div>
      {hoofdstuk.overlijdensRisicoVerzekeringen
        ?.slice(1)
        .map((verzekering: OverlijdensRisicoVerzekering, index) => {
          return (
            <div key={`verzekering-${index + 1}`}>
              {overlijdensrisicoverzekering({
                overlijdensrisicoverzekering: verzekering,
                index: index + 1,
              })}
            </div>
          );
        })}
    </Chapter>
  );
};

export default OverlijdensrisicoverzekeringChapter;
